import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLanguageFromPath, localizePath } from '../helper/localizedPath';

export function useLanguage() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lang = getLanguageFromPath(location.pathname, i18n.language);
  const isEn = lang === 'en';

  const switchLanguage = () => {
    const newLang = isEn ? 'cs' : 'en';
    i18n.changeLanguage(newLang);
    navigate(`${localizePath(location.pathname, newLang)}${location.search}${location.hash}`);
  };

  return { lang, isEn, switchLanguage };
}
